import { render } from "./ProfileStaffPerson.vue?vue&type=template&id=6931e462"
import script from "./ProfileStaffPerson.vue?vue&type=script&lang=js"
export * from "./ProfileStaffPerson.vue?vue&type=script&lang=js"
script.render = render

export default script